import cabecalho from '@/components/global/Cabecalho/Cabecalho.vue'
import menuLateral from '@/components/global/MenuLateral/MenuLateral.vue'
import spinnerProcessando from '@/components/layout/spinnerProcessamento/SpinnerProcessamento.vue'
import { BModal, BToast } from 'bootstrap-vue'
import mensagens from '@/util/mensagens'
import util from '@/util'
import defaultTable from '@/components/layout/defaultTable/DefaultTable.vue'
import { mapState } from 'vuex'
import pagination from '@/components/layout/pagination/Pagination.vue'
import { faturaMixin } from '@/modules/faturas/mixins'
import ListagemPedidos from '@/views/pedidos/ListagemPedidos.vue'

export default {
  name: 'faturas',
  components: {
    cabecalho,
    menuLateral,
    pagination,
    spinnerProcessando,
    ListagemPedidos,
    'b-modal': BModal,
    'b-toast': BToast,
    'default-table': defaultTable
  },
  mixins: [faturaMixin],

  computed: {
    tabelaSemRegistros () {
      return this.listaFaturas.length === 0
    },
    ...mapState('pagination', ['registrosPorPagina'])
  },

  data: () => {
    return {
      dadosVazio: false,
      listaFaturas: [],
      fields: [
        { key: 'servico', sortable: false, label: 'Serviço' },
        { key: 'data', sortable: false, label: 'Data Emissão' },
        { key: 'valor', sortable: false, label: 'Valor' },
        { key: 'acoes', sortable: false, label: '' }
      ],
      flagsDeControle: {
        carregandoDados: {
          status: false,
          mensagem: ''
        }
      },
      componentePaginacao: {
        pagina: 1,
        registrosPorPagina: null,
        fonteDeDados: [],
        ultimaPagina: 1
      }
    }
  },

  mounted () {
    this.componentePaginacao.registrosPorPagina = this.registrosPorPagina
    this.obterListaFaturas()
  },

  methods: {
    definirClasseLinha (item, type) {
      if (util.valorVazio(item) && type === 'row-empty') {
        return 'text-center trCorTextoPadrao'
      }
      return 'trCorTextoPadrao'
    },
    async obterListaFaturas () {
      this.definirFlagCarregandoDados(true, mensagens.carregandoDadosEdicao)

      try {
        let parametrosRequisicao = {
          'page': this.componentePaginacao.pagina,
          'registrosPorPagina': this.componentePaginacao.registrosPorPagina,
          'filtros': {
            'f_tipo': 1
          },
          'ordenacao': this.componenteOrdenacao
        }

        const resposta = await this.axios.post('/manager/conta/faturas', parametrosRequisicao)
        if (resposta.data.retorno.dados.length > 0) {
          this.listaFaturas = resposta.data.retorno.dados
          this.componentePaginacao.fonteDeDados = resposta.data.retorno.paginacao
          this.componentePaginacao.ultimaPagina = resposta.data.retorno.paginacao.ultimaPagina
        } else {
          this.dadosVazio = true
        }
      } catch (e) {
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaServidorCarregandoDados)
      }
      this.definirFlagCarregandoDados(false, '')
    },
    definirFlagCarregandoDados (status, mensagem) {
      this.flagsDeControle.carregandoDados.status = status
      this.flagsDeControle.carregandoDados.mensagem = mensagem
    },
    buscarRegistros () {
      this.obterListaFaturas()
      this.componentePaginacao.pagina = 1
    },
    obterDadosPaginados (pagina, registrosPorPagina) {
      this.componentePaginacao.pagina = pagina
      this.componentePaginacao.registrosPorPagina = registrosPorPagina
      this.obterListaFaturas()
    },
    formatarValorMonetario (valor) {
      return util.formatarValorMonetarioComCifrao(valor)
    },
    obterDescricaoPedido (fatura) {
      if (!util.valorVazio(fatura.descricao)) {
        return fatura.produto_nome + ' - ' + fatura.plano_nome
      }
    },
    encaminharParaPagamento (id) {
      this.$router.push({ name: 'carrinho', params: { idFatura: id, progresso: 2 } })
    }
  }
}
